module.exports = "/_next/static/images/AggregationIdentityResolution-b57d831abd1687fe7f1158a5995ce653.webp";